export const OLO_APPLICATION_NAME_HEADER = 'olo-application-name'
export const OLO_APPLICATION_NAME_VALUE = 'engage-host-public-widget'
